import { Box, Collapse, Grid, Group, Text, ThemeIcon } from "@mantine/core";
import {
  IconChevronDown,
  IconChevronUp,
  TablerIconsProps,
} from "@tabler/icons-react";

export const FakeAccordion = ({
  title,
  Icon,
  children,
  itemCount,
  isOpen,
  setIsOpen,
  colour,
}: {
  title: string;
  Icon: (props: TablerIconsProps) => JSX.Element;
  children: JSX.Element;
  itemCount?: number;
  isOpen: boolean;
  colour?: string;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const formattedTitle =
    itemCount !== undefined ? `${title} (${itemCount})` : title;

  return (
    <Grid.Col
      tabIndex={0}
      style={{
        cursor: "pointer",
        borderColor: "var(--mantine-color-dark-4)",
        borderWidth: "1px",
        borderStyle: "solid",
      }}
      px="lg"
      span={12}
    >
      <Box>
        <Group onClick={() => setIsOpen(!isOpen)}>
          <ThemeIcon color={`${colour}.9`}>
            <Icon opacity={0.6} />
          </ThemeIcon>
          <Text>{formattedTitle}</Text>
          <Box ml="auto">
            {isOpen ? <IconChevronUp /> : <IconChevronDown />}
          </Box>
        </Group>
        <Collapse
          mt="md"
          transitionDuration={(itemCount || 0) * 10 + 100}
          in={isOpen}
        >
          {isOpen && children}
        </Collapse>
      </Box>
    </Grid.Col>
  );
};
